/**
 * @fileoverview GET handler for the "/users/subscription_groups/usage/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { usersSubscriptionGroupsUsageId } from "./constants";
import type { UsersSubscriptionGroupsUsageIdResult } from "./types";

export const getUsersSubscriptionGroupsUsageId = reactQueryFetcherAdapter(
  usersSubscriptionGroupsUsageId,
  (signal: AbortSignal, id: string): Promise<UsersSubscriptionGroupsUsageIdResult> => {
    return fetch(`/users/subscription_groups/usage/${id}`, "GET", {}, { signal });
  }
);
